import React, { createContext, useContext, useEffect, useState } from "react";
import { adminApi, formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null); // null = checking, false = guest, obj = admin
  const token = localStorage.getItem("ee_admin_token");

  useEffect(() => {
    if (!token) {
      setAdmin(false);
      return;
    }
    adminApi
      .get("/auth/me")
      .then((r) => setAdmin(r.data))
      .catch(() => {
        localStorage.removeItem("ee_admin_token");
        setAdmin(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = async (email, password) => {
    try {
      const { data } = await adminApi.post("/auth/login", { email, password });
      localStorage.setItem("ee_admin_token", data.token);
      setAdmin(data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiError(e.response?.data?.detail) || e.message };
    }
  };

  const logout = async () => {
    try {
      await adminApi.post("/auth/logout");
    } catch (_) {}
    localStorage.removeItem("ee_admin_token");
    setAdmin(false);
  };

  return <AuthContext.Provider value={{ admin, login, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
